import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
    selector: '[vpViewHost]',
    standalone: false
})
export class ViewHostDirective {
    public viewContainerRef = inject(ViewContainerRef);
}
